import template from "./primary-selector.html";
import "./primary-selector.less";
import {
	some,
	uniqWith
} from "lodash";
import {
	ENTITY_TYPES,
	EVENT_LOGOUT
} from "constants.js";
import moment from "moment";
import {
	comparePeriodStartDateAscending, 
	entityEffectiveStatus 
} from "../../../utils/effectiveRanges";

export class Controller {
	entity = null;
	title = null;

	constructor($scope, eventBus, appState, $logger) {
		this._scope = $scope;
		this.eventBus = eventBus;
		this.form = appState.forms.selected;
		this.logger = $logger;
	}

	$onInit() {
		this.isShown = [];
		this.btnIsExpanded = null;
		const hasEffectiveRanges = some(this.resolve.entity.Entities, e => e.Entity.Effective?.length);

		if(hasEffectiveRanges) {
			const entitiesWithMostRecentStartRangeMoment = this.resolve.entity.Entities.map(e => {
				if(e.Entity.Effective === undefined) {
					this.logger.warn("Entity is missing effective ranges", { entity: e.Entity });
					return {
						...e, 
						Entity: {
							...e.Entity,
							mostRecentRangeStartMoment: moment.unix(0)
						}
					};
				}

				const sortedRanges = [...e.Entity.Effective].sort(comparePeriodStartDateAscending);

				const newEntity = {
					...e, 
					Entity: {
						...e.Entity,
						mostRecentRangeStartMoment: moment(sortedRanges[0])
					}
				};

				return newEntity;
			});

			const orderedEntities = entitiesWithMostRecentStartRangeMoment.sort((eOne, eTwo) => 
				eOne.Entity.mostRecentRangeStartMoment.isBefore(eTwo.Entity.mostRecentRangeStartMoment) ? -1 : 1
			);

			const hasValidEntities =  orderedEntities.some(item => item.Entity.valid === undefined || item.Entity.valid);

			this.entity = {
				...this.resolve.entity,
				Entities: hasValidEntities
					? orderedEntities.filter(item => item.Entity.valid === undefined || item.Entity.valid)
					: orderedEntities.filter(item => item.Entity.inGrace === undefined || item.Entity.inGrace),
				OutOfSeasonLicenses: orderedEntities.filter(item => 
					item.Entity.valid !== undefined 
					&& !item.Entity.valid
					&& !item.Entity.inGrace !== undefined
					&& !item.Entity.inGrace
				)
			};
		} 
		else {
			this.entity = { ...this.resolve.entity };
		}

		this.entity.Entities.forEach(e => {
			e.icon = ENTITY_TYPES[e.Entity.Type?.Code]?.Icon ?? ENTITY_TYPES["DEFAULT"]?.Icon;
			e.Entity.Identifiers = e.Entity.Identifiers && e.Entity.Identifiers.filter(id => id.Type.Code !== "TOKEN");

			let allClassifications = e.Entity.Classifications || [];
			if(!!e.Entity.Classification) {
				allClassifications = allClassifications.concat(e.Entity.Classification);
				allClassifications = uniqWith(allClassifications, (a, b) => a.Id === b.Id);
			}

			if(allClassifications.length > 0) {
				e.Entity.allClassifications = allClassifications;
			}

			const thisEntityAgencyType = this.form.Agency.Types.find(t => t.Code === e.Entity.Type.Code);
			e.Entity.shouldHideCode = thisEntityAgencyType.IsCodeSystemManaged;
		});

		this.isShown = (() => {
			const shown = [];
			this.entity.Entities.forEach(entity => {
				const identifiersCount = entity.Entity.Identifiers && entity.Entity.Identifiers.length;
				if(identifiersCount === 1) {
					shown.push(entity.Entity.Id);
				}
			});
			return shown;
		})();

		this.eventBus.register(
			EVENT_LOGOUT,
			() => {
				this.handleSelection();
			},
			this._scope
		);
	}

	handleClick(result) {
		if(result.Entity.valid !== false || result.Entity.inGrace !== false) {
			this.modalInstance.close(result.Entity);
		}
	}

	handleSelection(event, result) {
		if(document.activeElement.tagName !== "BUTTON") {
			if(event.keyCode === 13 || event.keyCode === 32) {
				event.stopImmediatePropagation();
				event.preventDefault();
				this.modalInstance.close(result.Entity);
			}
		}
	}

	getCount(count, name) {
		if(count === 0 || count === undefined) {
			return false;
		} else if(count > 1) {
			return `${count} ${name}s`;
		} else if(count === 1) {
			return `${count} ${name}`;
		}
	}

	getDate(entity) {
		if(!entity.Effective) {
			return false;
		} 

		if(this.resolve.asOfRange) {
			const asOfRange = this.resolve.asOfRange;
			const rangeStart = moment(asOfRange.fromInclusive);
			const asOfLabel = rangeStart.format("YYYY-MM-DD");
			const statusForAsOfRange = entityEffectiveStatus(this.resolve.entity, asOfRange);

			return statusForAsOfRange.isValid 
				? `Active for ${asOfLabel}`
				: statusForAsOfRange.isInGrace
					? `In Grace period for ${asOfLabel}`
					: `Inactive for ${asOfLabel}`;
		}

		const dates = entity.Effective?.map(range => `${moment(range.Start).format("YYYY-MM-DD")} - ${range.End ? moment(range.End).format("YYYY-MM-DD") : ""}`);
		const separated = dates.join(", ");

		return separated;
	}

	getMomentFormat(unformatted) {
		return moment(unformatted).format("L");
	}

	toggleButton(id, event) {
		event.preventDefault();
		event.stopPropagation();

		if(this.btnIsExpanded === id) {
			this.btnIsExpanded = null;
		} else {
			this.btnIsExpanded = id;
		}
		if(this.isShown.includes(id)) {
			this.isShown = this.isShown.filter(i => i !== id);
		} else {
			this.isShown.push(id);
		}
	}
	toggleButtonKeyUp(id, event) {
		if(event.key == 13 || event.keyCode == 32) {
			event.stopImmediatePropagation(); //stops button from rapidly and repeatedly toggling
			this.toggleButton(id, event);
		}
	}
}

export default angular.module("vesl.components.primary-selector", []).component("primarySelector", {
	controller: Controller,
	template,
	bindings: {
		close: "&",
		dismiss: "&",
		modalInstance: "<",
		resolve: "<"
	}
}).name;
